export const LIMIT = 15;
export const CONFIG = {
    type: 'error',
    title: 'Error',
    message: 'Please select valid user and/or correct any errors.'
  };